import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

const dialogPaperProps = {
  sx: {
    borderRadius: 3,
  },
};

export default function CardRedemptionDialogFrame({ actions, children, onClose, open, title }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={dialogPaperProps}>
      <DialogTitle sx={{ px: 3 }}>{title}</DialogTitle>
      <DialogContent dividers sx={{ px: 3 }}>
        {children}
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        {actions}
      </DialogActions>
    </Dialog>
  );
}

CardRedemptionDialogFrame.propTypes = {
  actions: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};
